import * as React from 'react';

import * as style from './Header.css';

const Header = React.forwardRef<HTMLDivElement, React.PropsWithChildren<{}>>((props, ref) => {
  const { children } = props;

  return (
    <div ref={ref} className={style['header']}>
      {children}
    </div>
  );
});

Header.displayName = 'Header';

export { Header };
